import { get } from 'lodash/fp';
import { useMemo } from 'react';
import { InsurerIntegrationProvider } from '../../../../api/types';
import useValidator from '../../../../utilities/useValidator';
import validators from '../../../../utilities/validators';
import { createInsurerIntegrationValidator } from './useInsurerIntegrationFormValidation';

const useInsurerFormValidator = (isUpdate = false) => {
    const validator = useMemo(
        () =>
            validators.compose(
                validators.requiredString('displayName'),
                validators.requiredString('legalName.defaultValue'),
                validators.requiredString('moduleId'),
                validators.requiredString('email'),
                validators.requiredNumber('order'),
                validators.validEmail('email'),

                validators.only(
                    () => !isUpdate,
                    validators.compose(
                        validators.requiredStringEnum('integrationProvider', InsurerIntegrationProvider),
                        validators.only(
                            values => get('integrationProvider', values) === InsurerIntegrationProvider.Email,
                            validators.nest(
                                'integrationSettings.email',
                                createInsurerIntegrationValidator(InsurerIntegrationProvider.Email)
                            )
                        ),

                        validators.only(
                            values => get('integrationProvider', values) === InsurerIntegrationProvider.Eazy,
                            validators.nest(
                                'integrationSettings.eazy',
                                createInsurerIntegrationValidator(InsurerIntegrationProvider.Eazy)
                            )
                        )
                    )
                )
            ),
        [isUpdate]
    );

    return useValidator(validator);
};

export default useInsurerFormValidator;
